/* Imports */
import React from "react"
import { v4 as uuid } from "uuid"
import { Table } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"

import allHelpers from "../../data/all-helpers"

const HelpersPage = () => {
    return (
        <ComponentPage>
            <Table tableStyle="bordered" vAlign="top">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Effect</th>
                    </tr>
                </thead>

                <tbody>
                    {allHelpers.map(helper => (
                        <tr key={uuid()}>
                            <td>{helper.name}</td>
                            <td>{helper.effect}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </ComponentPage>
    )
}

export default HelpersPage
